
import React from "react";
import { SubscriptionStatusCard } from "./SubscriptionStatusCard";
import { SubscriptionPlans } from "./SubscriptionPlans";
import { ExtendedOrganization } from "@/hooks/organization-settings/types";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TransactionHistory } from "./subscription/TransactionHistory";

interface SubscriptionSectionProps {
  organization: ExtendedOrganization | null;
}

export const SubscriptionSection: React.FC<SubscriptionSectionProps> = ({
  organization
}) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  // Créer une instance de QueryClient unique pour ce composant
  const queryClient = React.useMemo(() => new QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
      },
    },
  }), []);

  const handleChangePlan = () => {
    console.log("Navigating to pricing plans");
    toast({
      title: "Redirection",
      description: "Vous allez être redirigé vers la page des forfaits",
    });
    navigate("/plans");
  };

  return (
    <div className="md:col-span-2">
      <QueryClientProvider client={queryClient}>
        <div className="space-y-8 animate-in fade-in duration-500">
          <SubscriptionStatusCard organization={organization} />
          <SubscriptionPlans 
            organization={organization} 
            onChangePlan={handleChangePlan} 
          />
          {organization && <TransactionHistory organizationId={organization.id} />}
        </div>
      </QueryClientProvider>
    </div>
  );
};
